<div class="page-wraper" appSpin [spinnerConfig]="spinnerConfig()">
    <header class="bg-primary px-4 py-2">
        <img ngSrc="/assets/images/logo/countable-header-logo.svg" alt="Countable" width="130" height="23">
    </header>
    <div class="page-title-block bg-white">
        <h1 class="title h3">Entity Name:
            <span>{{ client?.entityName ? client.entityName : client?.cleintLegalCorporationName }}</span></h1>
    </div>
    <div class="content-block-main gap-20">

        <!-- <div class="no-data-found" *ngIf="!dataLoaded">
            <img ngSrc="/assets/images/loader.gif" width="40" alt="loading ..." height="40">
        </div> -->

        <ng-container *ngIf="dataLoaded">
            <!-- source is connected -->
            <ng-container *ngIf="tenantInfo && integration && !isRedirecting">
                <!-- when there is next step like sage organization select -->
                <ng-container *ngIf="integration.needExtraStepAfterAuth && !tenantInfo.tenant">
                    <div class="card mx-auto" style="max-width: 400px;">
                        <div class="card-body justify-content-center gap-32">
                            <img class="mx-auto" ngSrc="/assets/images/sage-logo.png" alt="Sage" width="110px"
                                 height="62px"/>
                            <h3 class="title">Please Select your company</h3>
                            <div class="ng-form-field w-100">
                                <label class="required">Please select your business:</label>
                                <ng-select [items]="organizationsList"
                                           bindLabel="organization"
                                           [placeholder]="selectedOrganization != null ? '': 'Please select your business'"
                                           [(ngModel)]="selectedOrganization">
                                </ng-select>
                            </div>
                            <div class="button-group">
                                <button mat-button mat-stroked-button color="dark" class="button-default flex-1"
                                        (click)="disconnect()">
                                    Cancel
                                </button>
                                <button mat-button mat-flat-button color="primary" class="button-default flex-1"
                                        [disabled]="selectedOrganization == null" (click)="saveOrganization()">
                                    Finish
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
                <!-- when there is no next step -->
                <ng-container
                        *ngIf="!integration.needExtraStepAfterAuth || (integration.needExtraStepAfterAuth && tenantInfo.tenant)">
                    <div class="card">
                        <div class="card-header min-h-auto">
                            <h5 class="title"><span *ngIf="!isConnected">Was </span>Connected to:</h5>
                        </div>
                        <div class="card-body">
                            <div class="vertical-items justify-content-between align-items-center acc-integration-icon"
                                 style="margin: 10px;">
                                <button mat-button class="button-text" title="{{integration.label}}">
                                    <img src="{{integration.imgPathLogo}}" alt="{{integration.label}}" class="acc-img"
                                         style="max-height:50px;max-width:initial;"/>
                                </button>
                                <h5 class="title" [ngClass]="{'strike-text': !isConnected}" *ngIf="tenantInfo !== null">
                                    {{ tenantInfo.organization }}
                                </h5>
                                <button *ngIf="isConnected" mat-button class="button-text"
                                        (click)="openDisconnectPopup()">
                                    <img src="{{integration.imgPathDisconnect}}" alt="Disconnect" class="acc-img"
                                         style="max-height:50px; max-width:initial;"/>
                                </button>
                                <button *ngIf="!isConnected" mat-button class="button-text"
                                        (click)="isRedirecting = true; oauthKickOff(integration);">
                                    <img class="integration-img-connect acc-img" src="{{integration.imgPathConnect}}"
                                         alt="{{integration.label}}" style="max-height:50px; max-width:initial;"/>
                                </button>
                            </div>
                            <h6 *ngIf="!isConnected" class="title text-error" style="margin: 20px 5px;">
                                Connection is broken, please authorize Countable to your client again.
                            </h6>
                        </div>
                    </div>
                </ng-container>
            </ng-container>
            <!-- no source is connected, show all sources -->
            <ng-container *ngIf="!tenantInfo || isRedirecting">
                <div class="integrations-setup-header">
                    <h4 *ngIf="!isRedirecting">Accounting Software:</h4>
                    <h4 *ngIf="isRedirecting">Redirecting, please wait ...</h4>
                </div>
                <!-- <div *ngIf="isRedirecting">
                    <hr>
                    <span class="badge badge-small badge-pills gap-4" style="height: fit-content;">
                        <img src="/assets/images/loader.gif" style="width: 32px;" alt="loading ...">
                    </span>
                </div> -->
                <div *ngIf="!isRedirecting" class="integrations-setup-row account-height-adj">
                    <div class="flex-box-row upload-integration-container">
                        <div class="integration-box">
                            <ng-container *ngFor="let i of integrations">
                                <div class="integration-item">
                                    <button class="integration-button" title="{{i.name}}"
                                            (click)="isRedirecting = true; oauthKickOff(i);">
                                        <img class="integration-img-connect"
                                             src="{{i.imgPathConnect}}"
                                             alt="{{i.label}}"/>
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </ng-container>
        </ng-container>

        <div *ngIf="dataLoaded && !(integration && integration.needExtraStepAfterAuth && tenantInfo && !tenantInfo.tenant)"
             class="button-group justify-content-end">
            <button mat-button mat-flat-button color="primary" class="button-default" (click)="closeWindow()">Close
            </button>
        </div>
    </div>
</div>

<!-- delete connection popup-->
<ng-template #disconnectDialog>
    <div class="countable-dialog confirmation-dailog" (click)="$event.stopPropagation()">
        <div mat-dialog-title class="dialog-header">
          <span class="badge badge-warning badge-circle icon-bordered-warning">
            <i class="fa-regular fa-triangle-exclamation text-warning"></i>
          </span>
            <h4 class="title">Disconnect</h4>
            <img src="{{integration.imgPathLogo}}" alt="{{integration.label}}" style="max-height:50px;">
            <button color="error" class="close" [mat-dialog-close]="false">
                <i class="fa-regular fa-xmark clear-icon"></i>
            </button>
        </div>

        <div mat-dialog-content class="dialog-body-content">
            <p class="fw-semibold">Are you sure you want to disconnect from {{ integration.label }}?</p>
            <p>You will be losing all engagement data</p>
        </div>

        <div mat-dialog-actions class="dialog-footer">
            <button mat-button mat-stroked-button class="button-default" color="dark"
                    [mat-dialog-close]="false">No
            </button>
            <button mat-button mat-flat-button class="button-default" color="primary"
                    [mat-dialog-close]="true" (click)="disconnect()">Yes
            </button>
        </div>
    </div>
</ng-template>
